import TitleField from './title';
import FileUploadField from './file';
import { TableEditorField } from './tableEditor/tableEditor.field';

export const fieldsReader = {
  FileUploadField: FileUploadField,
  TitleField: TitleField,
  DataEditorWidget: TableEditorField
} as Record<string, any>;
